(() => {
  const ROOT_SELECTOR = '[data-pq-bestsellers]';

  const refreshProductFeatures = () => {
    window.MinimogTheme?.Wishlist?.setWishlistButtonsState();
    window.MinimogTheme?.CompareProduct?.setCompareButtonsState();
    window.MinimogEvents?.emit?.('ON_PRODUCT_LIST_UPDATED');
  };

  const initialize = (root) => {
    if (!root || root.dataset.pqBestsellersReady === 'true') return;

    const tabs = Array.from(root.querySelectorAll('[data-pq-bestsellers-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-pq-bestsellers-panel]'));
    if (!tabs.length || tabs.length !== panels.length) return;

    root.dataset.pqBestsellersReady = 'true';

    const activate = (index, moveFocus = false) => {
      tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        panels[tabIndex].hidden = !active;
      });

      if (moveFocus) tabs[index].focus();
      tabs[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      refreshProductFeatures();
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(index));
      tab.addEventListener('keydown', (event) => {
        let targetIndex = index;
        if (event.key === 'ArrowRight') targetIndex = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') targetIndex = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') targetIndex = 0;
        else if (event.key === 'End') targetIndex = tabs.length - 1;
        else return;

        event.preventDefault();
        activate(targetIndex, true);
      });
    });

    refreshProductFeatures();
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initialize);
  };

  document.addEventListener('DOMContentLoaded', () => initializeAll());
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  initializeAll();
})();
